/**
 * Created by esenckewitch on 24.06.2026
 *
 * https://docs.crazygames.com/sdk/in-game-purchases/
 */
const CrazyLogger = function () {
    this.config = {
        lifetime: "180 days"
    };
};

CrazyLogger.prototype.trackPurchase = function (product, purchase, params) {
    try {
        CrazyGames.SDK.analytics.trackOrder("xsolla", {
            orderId: String(params.transactionId || purchase.paymentId),
            status: "done"
        });
    } catch (e) {
        console.log("CrazyGames trackOrder error", e);
    }
};

CrazyLogger.isApplicable = function () {
    return connector.platform.oneOf(connector.CRAZY);
};
